<mat-card>

    <h3 class="col-md-12"> Protection des données personnelles</h3>
    <p class="col-md-12">Lors de votre navigation sur ce site, l’Institut Gustave Roussy (Gustave Roussy) est amené à collecter
         et à utiliser certaines de vos données personnelles en sa qualité de responsable de traitement.
    </p>



<p class="col-md-12">
    <b>Adresse juridique</b><br/>
    Institut Gustave Roussy<br/>
    39 bis, rue Camille Desmoulins<br/>
    94 805 Villejuif Cedex<br/>
    Tél.: 01 42 11 42 11<br/>
</p>
<h5 class="col-md-12">Pourquoi certaines de vos données sont-elles collectées ?</h5>
<p class="col-md-12">
        Les données personnelles recueillies via ce site internet permettent aux professionnels compétents de Gustave Roussy de :<br/>
        <li class="retrait">Vous fournir un service de gestion de rendez-vous médical en ligne ;</li>
        <li class="retrait">Vous offrir une navigation optimale sur le site : adaptation de l’affichage en fonction du terminal utilisé, détection de la langue de l’utilisateur, etc. ;</li>
        <li class="retrait">Réaliser des analyses statistiques des visites sur notre site et ainsi l’optimiser.</li>
</p>

<h5 class="col-md-12">Quelles données vous concernant sont collectées ?</h5>
<p class="col-md-12">Gustave Roussy collecte vos données personnelles lorsque vous remplissez le formulaire de gestion de rendez-vous (RDV) en ligne.<br/>
<b>Par le biais du formulaire de gestion de RDV en ligne</b><br/>
Lorsque vous remplissez ce formulaire, les informations suivantes vous concernant sont recueillies par Gustave Roussy :
    <li class="retrait"><u>Identité du patient</u> : nom de famille, nom de jeune fille (si différent du nom de famille), prénom(s), sexe, date de naissance ; </li>
    <li class="retrait"><u>Identité du médecin</u> : numéro RPPS, nom de famille, prénom(s), adresse email ; numéro de téléphone, </li>
    <li class="retrait"><u>Identité du demandeur (si différent du patient)</u> : Nom de famille, prénom(s), lien avec le patient, numéro de téléphone portable, adresse e-mail ; </li>
    <li class="retrait"><u>Contact du patient</u> : numéros de téléphone, adresse e-mail, préférence pour être contacté par Gustave Roussy ; </li>
    <li class="retrait"><u>Demande</u> : spécialité ou organe concerné, antécédents médicaux ; </li>
    <li class="retrait"><u>Documents médicaux administratifs</u> : courrier de votre médecin, comptes rendus médicaux, bilan sanguin, etc.</li>
</p>

<h5 class="col-md-12">Vos données sont-elles partagées avec des tiers ?</h5>
<p class="col-md-12">Certaines de vos données personnelles sont susceptibles d’être partagées avec certains de nos prestataires, lesquels accompagnent Gustave Roussy notamment pour :
    <li class="retrait">L’éditeur de notre site internet (Jasparo).</li>

Gustave Roussy s’engage à ne partager ces données qu’avec ces seuls prestataires.
</p>

<h5 class="col-md-12">Combien de temps vos données seront-elles conservées ?</h5>
<p class="col-md-12">Gustave Roussy veille à conserver vos données personnelles pendant une durée qui n’excède pas la durée 
    nécessaire aux finalités exposées ici ou conformément à ce qui est prévu par la loi applicable.<br/><br/>
    Les données hors cookies sont conservées pendant une durée de 3 ans à compter de leur collecte.
</p>

<h5 class="col-md-12">Sur quels fondements juridiques repose le traitement de vos données ?</h5>
<p class="col-md-12">Les traitements de vos données collectées sur notre site ont pour fondements juridiques :<br/>
    <li class="retrait">Votre consentement pour l’instruction de votre demande de RDV par les professionnels compétents de Gustave Roussy ;</li>
    <li class="retrait">La poursuite d’intérêt légitime pour le dépôt et la gestion de cookies fonctionnels afin d'assurer le bon fonctionnement du site</li>
</p>

<h5 class="col-md-12">Comment pouvez-vous exercer vos droits ?</h5>
<p class="col-md-12">Conformément à la règlementation générale relative à la protection des données, vous bénéficiez de droits d’accès, de rectification, d’opposition, de suppression et de portabilité de vos données.<br/>
Pour exercer vos droits, vous pouvez adresser une demande expresse accompagnée d’un justificatif d’identité valide au délégué à la protection des données de Gustave Roussy, soit :<br/>
    <li class="retrait">par courriel : <a href="mailto:donneespersonnelles@gustaveroussy.fr ">donneespersonnelles&#64;gustaveroussy.fr</a> ;</li>
    <li class="retrait">par voie postale : Institut Gustave Roussy, Délégué à la protection des données, Direction de la Transformation Numérique et des Systèmes d’Information, 114, rue Edouard-Vaillant, 94 805 Villejuif Cedex – France.</li>
<br/><br/>
Au cas où il ne vous serait pas donné satisfaction, vous pouvez également effectuer une réclamation auprès de la Commission nationale informatique et libertés (Cnil) :
<a href="https://www.cnil.fr/fr/plaintes" target="_blank">https://www.cnil.fr/fr/plaintes</a>  
</p>
</mat-card>
